import { createFileRoute } from '@tanstack/react-router'

import { ensureUserTermsQueryData } from '../-utils/ensureUserTermsQueryData'

export const Route = createFileRoute('/_initialized/activateCard')({
  loader: ({ context }) => ensureUserTermsQueryData(context),
})
